import { render } from "./zcfgResource.vue?vue&type=template&id=28c2cdf2&scoped=true"
import script from "./zcfgResource.vue?vue&type=script&lang=js"
export * from "./zcfgResource.vue?vue&type=script&lang=js"

import "./zcfgResource.vue?vue&type=style&index=0&id=28c2cdf2&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c2cdf2"]])

export default __exports__